export default __webpack_public_path__ + "static/media/banner3.0f17d8c1.png";